import { useNavigate, useRouteError } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";

/**
 * `errorElement` das rotas: contém o crash na tela que falhou em vez de
 * derrubar o app inteiro — foi exatamente o que aconteceu em produção quando
 * uma data nula estourou no formatador da tela de aluguéis (11/jun).
 *
 * Ver `docs/PENDING.md` — as rotas antigas ainda não têm; toda rota nova tem.
 */
export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const detail =
    error instanceof Error
      ? error.message
      : "Ocorreu um erro inesperado ao carregar esta tela.";

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <AlertTriangle className="w-10 h-10 mx-auto text-destructive" />
        <div className="space-y-1">
          <h1 className="text-xl font-semibold text-foreground">
            Algo deu errado nesta tela
          </h1>
          <p className="text-sm text-muted-foreground break-words">{detail}</p>
        </div>
        <div className="flex items-center justify-center gap-2">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Voltar
          </Button>
          <Button onClick={() => window.location.reload()}>
            Recarregar a página
          </Button>
        </div>
      </div>
    </div>
  );
};
